<div class="flex items-center w-full  ">
  <a [routerLink]="linkData" [target]="blank ? '_blank' : ''" [ngClass]="class" class="cursor-pointer outline-none py-1 w-max">
    {{text}}
  </a>
  <div *ngIf="haveNoti" class="bg-red-500 rounded-full flex justify-center items-center text-white ml-1 text-xs px-1">
    new
  </div>
</div>